import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
    Box,
    createStyles, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Icon,
    IconButton, Input, InputAdornment, InputLabel, makeStyles, MenuItem, Radio, RadioGroup, Select, TextField, Theme, Typography
} from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { InfluencerContext } from '../NewsContext';

import { ClassificationInfluencerModel } from '../../../Models/ClassificationInfluencerModel';
import { HomeContext } from '../../Home/HomeContext';
import { NewsLoadingContext } from '../NewsLoadingContext';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import { format } from 'date-fns';
import { InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import InfluencerService from '../../../Services/InfluencerService';
import { theme } from '../../../theme';
import { CompanyModel } from '../../../Models/CompanyModel';
import { ClassificationCompanyModel } from '../../../Models/ClassificationCompanyModel';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) => createStyles({
    itens: {
        width: '100%',
        color: 'primary',
    },
    itemData: {
        width: '100%',
        color: 'primary',
        paddingBottom: theme.spacing(1.5),

    },
    linkColor: {
        color: '#2C64D0',
        textOverflow: 'ellipsis',
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    editText: {
        textOverflow: 'ellipsis',
    },
    yellowBackground: {
        backgroundColor: theme.palette.warning.light
    },
    outsideGrid: {
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loading: {
        minHeight: '20vh'
    },
    linksPaperError: {
        padding: theme.spacing(3),
        border: `1px solid ${theme.palette.error.main}`,
    },
    errorText: {
        paddingLeft: theme.spacing(2)
    }
}));
interface NewsDataProps {
    news: CompanyModel | null;
    setNews: (news: CompanyModel) => void;
    newsCurrentId: number | null;
    setNewsCurrentId: (currentId: number | null) => void;
}

type ErrosFormulario = Partial<Record<keyof CompanyModel, string>>;
export function validateCompanyData(news: CompanyModel) {
    const errors: any = {};
    if (!news.marcaId) errors.marcaId = true;
    if (!news.areaId) errors.areaId = true;
    if (!news.vpId) errors.vp = true;
    if (!news.nome || !news.nome.trim()) errors.nome = true;
    if (!news.objetivo || !news.objetivo.trim()) errors.objetivo = true;
    if (news.divulgacaoParceria == 1) {
        if (!news.canaisId || !Array.isArray(news.canaisId) || news.canaisId.length === 0) errors.canaisICE = true;
    }
    // if (!news.publicoAlvo || !news.publicoAlvo.trim()) errors.publicoAlvo = true;
    // if (!news.periodoCampanha) errors.periodoCampanha = true;
    // if (
    //     news.envolvimentoCampanha === null ||
    //     news.envolvimentoCampanha === undefined ||
    //     news.envolvimentoCampanha === ''
    // ) errors.envolvimentoCampanha = true;
    if (!news.abrangenciaId && news.abrangenciaId !== 0) errors.abrangenciaId = true;

    return errors;
}
function toBrasiliaISOString(date: Date) {
    const offsetMs = 3 * 60 * 60 * 1000;
    const brasiliaDate = new Date(date.getTime() - offsetMs);
    return brasiliaDate.toISOString().slice(0, 19); // 'YYYY-MM-DDTHH:mm:ss'
}


export default function CampaignData({ news, setNews, }: NewsDataProps) {
    const classes = useStyles();

    const newsLoadingContext = React.useContext(NewsLoadingContext);
    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;
    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [erros, setErros] = React.useState<ErrosFormulario>({} as ErrosFormulario);
    const [loading, setLoading] = React.useState(false);

    const [nomeDisabled, setNomeDisabled] = React.useState(true);
    const [nomeFocused, setNomeFocused] = React.useState(false);

    const [siteEmpresaDisabled, setSiteEmpresaDisabled] = React.useState(true);
    const [siteEmpresaFocused, setSiteEmpresaFocused] = React.useState(false);

    const [iniciativaDisabled, setIniciativaDisabled] = React.useState(true);
    const [iniciativaFocused, setIniciativaFocused] = React.useState(false);

    const [periodoAcaoDisabled, setPeriodoAcaoDisabled] = React.useState(true);
    const [periodoAcaoFocused, setPeriodoAcaoFocused] = React.useState(false);


    const [objetivoContratacaoDisabled, setObjetivoContratacaoDisabled] = React.useState(true);
    const [objetivoContratacaoFocused, setObjetivoContratacaoFocused] = React.useState(false);



    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => {
                    setFiltersData(res.data);

                    setLoading(false);
                })
                .catch((error: AxiosError) => { setLoading(false); homeContext.showError('', error); });
        }

    }, []);

    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
    };

    const handleChange = (prop: keyof ClassificationCompanyModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        setNews({ ...news, [prop]: event.target.value });
    };

    // const handleChangeSelect = (prop: keyof ClassificationCompanyModel) =>
    //     (event: React.ChangeEvent<{ value: unknown }>) => {
    //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //         //@ts-ignore
    //         setNews({ ...news, [prop]: event.target.value as string });
    //     };

    const handleChangeSelect = (prop: keyof ClassificationCompanyModel) =>
        (event: React.ChangeEvent<{ value: unknown }>) => {
            const value = event.target.value;
            // Se for o campo divulgacaoParceria e valor "Não" (0, '0', false, 'false'), limpa canais
            if (prop === 'divulgacaoParceria' && (value === 0 || value === '0' || value === false || value === 'false')) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                setNews({ ...news, [prop]: event.target.value, canaisId: [] });
            } else {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                setNews({ ...news, [prop]: event.target.value as string });
            }
        };


    const handleChangeDate = (prop: keyof CompanyModel) =>
        (date: Date | null) => {
            if (date) {
                if (news) {
                    setNews({ ...news, [prop]: toBrasiliaISOString(date) });
                }
            }
        };

    const handleChangeSelectCanais = (prop: keyof ClassificationCompanyModel) =>
        (event: React.ChangeEvent<{ value: unknown }>) => {
            const value = event.target.value;
            // value pode ser um array de ids (ex: [1,2,3])
            const canaisArray = Array.isArray(value)
                ? value.map((id_aux) => ({ id_aux }))
                : [];
            setNews({ ...(news as CompanyModel), [prop]: canaisArray });
        };

    const handleChangeContextoParceria = (prop: keyof CompanyModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        setNews({ ...news, [prop]: `1|${event.target.value}` });
    };

    // const getContextoTipoRelacionamento = () => {
    //     const valor = news?.tipoRelacionamento;
    //     if (typeof valor === 'string' && valor.startsWith('1|')) {
    //         return valor.split('|')[1];
    //     }
    //     return '';
    // };


    // const getContextoParceira = () => {
    //     const valor = news?.parceiraGB;
    //     if (typeof valor === 'string' && valor.startsWith('1|')) {
    //         return valor.split('|')[1];
    //     }
    //     return '';
    // };

    const validarCampos = (): ErrosFormulario => {
        const novosErros: ErrosFormulario = {};

        const camposObrigatorios: (keyof CompanyModel)[] = [
            'area',
            'marca',
            'vp',
            'nome',
            'url_perfil',
            'iniciativa',
            'finalidade',
            'formato',
            'canais',
            'abrangencia',
        ];

        camposObrigatorios.forEach((campo) => {
            if (news) {
                const valor = news[campo];
                if (typeof valor === 'string' && !valor.trim()) {
                    novosErros[campo] = 'Campo obrigatório.';
                } else if (valor === null || valor === undefined) {
                    novosErros[campo] = 'Campo obrigatório.';
                }
            }
        });
        return novosErros;
    };

    const getDate = () => {
        return (
            <Grid item xs={6}>
                <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                    <DatePicker
                        id="news-date"
                        variant="inline"
                        value={news?.dataAnalise}
                        inputVariant="outlined"
                        label="Data de upload"
                        minDate={new Date('0000-00-00')}
                        onChange={(date) =>
                            date !== null ? '' : ''
                        }
                        InputProps={{
                            readOnly: true,
                        }}
                        format="dd/MM/yyyy"
                        className={classes.itemData}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
        );
    };

    const getNomeSolicitante = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="nomeSolicitante"
                        value={news?.solicitante}
                        onChange={() => { return; }}
                        label="Nome Solicitante"
                        variant="outlined"
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const getResponsavelReputacao = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="responsavelReputacao"
                        value={news?.responsavelReputacao}
                        onChange={() => { return; }}
                        label="Responsável Reputação"
                        variant="outlined"
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const getEmail = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="E-mail"
                        value={news?.email}
                        onChange={() => { return; }}
                        label="E-mail"
                        variant="outlined"
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const getDataRecebimento = () => {
        const dataAtualFormatada = news?.dataRecebimento ? format(new Date(news.dataRecebimento), 'dd/MM/yyyy') : '';
        return (
            <Grid item xs={4}>
                <TextField
                    id="news-date"
                    label="Data"
                    value={dataAtualFormatada}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
            </Grid>
        );
    };



    const getNomeFiguraPublica = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="nomeEmpresa"
                        value={news?.nome}
                        onChange={handleChange('nome')}
                        label="Nome da Empresa/Evento"
                        variant="outlined"
                        disabled={nomeDisabled}
                        className={classes.itens}
                        onBlur={() => { setNomeDisabled(true); setNomeFocused(false); }}
                        inputRef={input => nomeFocused && input && input.focus()}
                        InputProps={{
                            endAdornment: (nomeDisabled &&
                                <InputAdornment position="end">
                                    <IconButton onClick={() => { setNomeDisabled(!nomeDisabled); setNomeFocused(true); }}>
                                        <Icon>edit</Icon>
                                    </IconButton>
                                </InputAdornment>)
                        }}
                    />
                    {erros.nome && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };
    const getSiteEmpresa = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="siteEmpresa"
                        value={news?.siteEmpresa}
                        onChange={handleChange('siteEmpresa')}
                        label="Site da empresa/evento"
                        variant="outlined"
                        disabled={siteEmpresaDisabled}
                        className={classes.itens}
                        onBlur={() => { setSiteEmpresaDisabled(true); setSiteEmpresaFocused(false); }}
                        inputRef={input => siteEmpresaFocused && input && input.focus()}
                        InputProps={{
                            endAdornment: (siteEmpresaDisabled &&
                                <InputAdornment position="end">
                                    <IconButton onClick={() => { setSiteEmpresaDisabled(!siteEmpresaDisabled); setSiteEmpresaFocused(true); }}>
                                        <Icon>edit</Icon>
                                    </IconButton>
                                </InputAdornment>)
                        }}
                    />
                    {erros.siteEmpresa && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };

    const getPeriodoAcao = () => {
        return (
            <Grid item xs={8} >
                <Grid container spacing={4}>
                    <Grid item xs={6}>
                        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                            <DatePicker
                                id="periodo-acao-inicio"
                                variant="inline"
                                value={news?.periodoAcao ?? null}
                                inputVariant="outlined"
                                label="Início do Período da Ação"
                                minDate={new Date(0)}
                                clearable
                                emptyLabel=''
                                onChange={handleChangeDate('periodoAcao')}
                                format="dd/MM/yyyy"
                                className={classes.itens}
                                required error={!!erros.periodoAcao}
                            />
                            {erros.periodoAcao && (
                                <FormHelperText>Campo obrigatório.</FormHelperText>
                            )}
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                            <DatePicker
                                id="periodo-acao-fim"
                                variant="inline"
                                value={news?.periodoAcaoFim ?? null}
                                inputVariant="outlined"
                                label="Fim do Período da Ação"
                                minDate={news?.periodoAcao ?? new Date(0)}
                                clearable
                                emptyLabel=''
                                onChange={handleChangeDate('periodoAcaoFim')}
                                format="dd/MM/yyyy"
                                className={classes.itens}
                                required error={!!erros.periodoAcaoFim}
                            />
                            {erros.periodoAcaoFim && (
                                <FormHelperText>Campo obrigatório.</FormHelperText>
                            )}
                        </MuiPickersUtilsProvider>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const getObservacoes = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="observacaoes"
                        value={news?.observacoes || ''}
                        onChange={handleChange('observacoes')}
                        label="Observações"
                        variant="outlined"
                        multiline
                        minRows={3}
                        maxRows={3}
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const selectMarca = () => {
        const isEmpty = news?.marcaId === null || news?.marcaId === undefined || news?.marcaId === 0;

        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.marcaId || isEmpty}
                >
                    <Autocomplete
                        id="marca-autocomplete"
                        options={filters?.marcas ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.marcas?.find(m => m.id_aux === news?.marcaId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                marcaId: newValue ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Marca"
                                variant="outlined"
                                error={!!erros.marcaId || isEmpty}
                                required
                            />
                        )}
                    />
                    {((erros.marcaId || isEmpty)) && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectArea = () => {
        const isEmpty = news?.areaId === null || news?.areaId === undefined || news?.areaId === 0;
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={Boolean(erros.areaId) || isEmpty}
                >
                    <Autocomplete
                        id="area-autocomplete"
                        options={filters?.area ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.area?.find(a => a.id_aux === news?.areaId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                areaId: newValue ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Área"
                                variant="outlined"
                                error={Boolean(erros.areaId) || isEmpty}
                                required
                                helperText={(Boolean(erros.areaId) || isEmpty) ? 'Este campo é obrigatório.' : ''}
                            />
                        )}
                    />
                </FormControl>
            </Grid>
        );
    };

    const selectVp = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.vp}
                >
                    <Autocomplete
                        id="vp-autocomplete"
                        options={filters?.vp ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.vp?.find(v => v.id_aux === news?.vpId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                vpId: newValue ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="VP"
                                variant="outlined"
                                error={!!erros.vp}
                                required
                            />
                        )}
                    />
                    {erros.vp && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };


    const selectCanais = () => {
        const isEmpty = news?.canaisId === null || news?.canaisId === undefined;

        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.canaisICE || isEmpty}
                >
                    <Autocomplete
                        multiple
                        id="canais-autocomplete"
                        options={filters?.canais ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.canais?.filter((c) => Array.isArray(news?.canaisId) && news?.canaisId?.some((n) => n.id_aux === c.id_aux)) || []}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                canaisId: newValue
                                    .filter((c) => typeof c.id_aux === 'number')
                                    .map((c) => ({ id_aux: c.id_aux as number })),
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Canais de divulgação"
                                variant="outlined"
                                error={!!erros.canaisICE || isEmpty}
                                required
                            />
                        )}
                        disableCloseOnSelect
                    />
                    {(!!erros.canaisICE || isEmpty || (Array.isArray(news?.canaisId) && news.canaisId.length === 0)) && (
                        <FormHelperText error>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };


    const selectParceiraGB = () => {

        return (
            <>
                <Grid item xs={4}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        required error={!!erros.parceiraGB}
                    >
                        <InputLabel id="submit-select" style={{ color: 'black' }}>
                            Já foi ou é uma parceira GB?
                        </InputLabel>
                        <Select
                            labelId="submit-select"
                            id="submit-select"
                            label="Já foi ou é uma parceira GB?"
                            value={news?.parceiraGB}
                            onChange={handleChangeSelect('parceiraGB')}
                        >
                            <MenuItem value="">Selecione</MenuItem>
                            <MenuItem value={1}>Sim</MenuItem>
                            <MenuItem value={0}>Não</MenuItem>
                        </Select>
                        {erros.parceiraGB && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                {news?.parceiraGB === 1 && (
                    <Grid item xs={8}>
                        <TextField
                            label="Contexto da parceria"
                            variant="outlined"
                            fullWidth
                            value={news.parceiraGBContext || ''}
                            onChange={handleChange('parceiraGBContext')}
                            required
                            error={news?.parceiraGBContext === undefined || news?.parceiraGBContext === ''}
                        />
                        {news?.parceiraGBContext && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </Grid>
                )}
            </>
        );
    };

    const selectTipoRelacionamento = () => {
        const outrosItem = filters?.tipo_relacionamento?.find(item => item.descricao?.toLowerCase() === 'outro');
        const outrosId = outrosItem?.id_aux;
        return (
            <>
                <Grid item xs={4}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        required error={!!erros.tipoRelacionamento}
                    >
                        <InputLabel id="submit-select" style={{ color: 'black' }}>
                            Tipo de relacionamento/patrocínio
                        </InputLabel>
                        <Select
                            labelId="submit-select"
                            id="submit-select"
                            label="Tipo de relacionamento/patrocínio"
                            value={news?.tipoRelacionamento ?? ''}
                            onChange={handleChangeSelect('tipoRelacionamento')}
                        >
                            <MenuItem value="">Selecione</MenuItem>
                            {filters?.tipo_relacionamento?.map((item) => (
                                <MenuItem key={item.id} value={item.id_aux}>
                                    {item.descricao}
                                </MenuItem>
                            ))}
                        </Select>
                        {erros.tipoRelacionamento && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                {news?.tipoRelacionamento === outrosId && (
                    <Grid item xs={8}>
                        <TextField
                            label="Contexto do relacionamento"
                            variant="outlined"
                            fullWidth
                            value={news?.tipoRelacionamentoContext || ''}
                            onChange={handleChange('tipoRelacionamentoContext')}
                            required
                            error={!news?.tipoRelacionamentoContext || news.tipoRelacionamentoContext.trim() === ''}
                        />
                        {(!news?.tipoRelacionamentoContext || news.tipoRelacionamentoContext.trim() === '') && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </Grid>
                )}
            </>
        );
    };


    const selectDivulgacaoParceria = () => {
        return (
            <>
                <Grid item xs={4}>
                    <FormControl
                        variant="outlined"
                        style={{ width: '100%' }}
                        required error={!!erros.divulgacaoParceria}
                    >
                        <InputLabel id="submit-select" style={{ color: 'black' }}>Haverá divulgação sobre a parceria?</InputLabel>
                        <Select
                            labelId="submit-select"
                            id="submit-select"
                            value={news?.divulgacaoParceria ?? ''}
                            label="Haverá divulgação sobre a parceria?"
                            onChange={handleChangeSelect('divulgacaoParceria')}
                            style={{
                                outline: 'none',
                                borderBottom: 'none',
                            }}
                        >
                            <MenuItem value="">Selecione</MenuItem>
                            <MenuItem value={1}>Sim</MenuItem>
                            <MenuItem value={0}>Não</MenuItem>
                        </Select>
                        {erros.divulgacaoParceria && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
            </>
        );
    };



    const selectAbrangencia = () => {
        const isEmpty = news?.abrangenciaId === null || news?.abrangenciaId === undefined;
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required error={!!erros.abrangenciaId || isEmpty}
                >
                    <Autocomplete
                        id="abrangencia-autocomplete"
                        options={filters?.abrangencia ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.abrangencia?.find(a => a.id_aux === news?.abrangenciaId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                abrangenciaId: newValue && typeof newValue.id_aux === 'number' ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Abrangência"
                                variant="outlined"
                                error={!!erros.abrangenciaId || isEmpty}
                                required
                            />
                        )}
                    />
                    {(erros.abrangenciaId || isEmpty) && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };



    const getObjetivoContratacao = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="objetivoContratacao"
                        value={news?.objetivo}
                        label="Objetivo/ conceito da iniciativa"
                        variant="outlined"
                        onChange={handleChange('objetivo')}
                        disabled={objetivoContratacaoDisabled}
                        className={classes.itens}
                        multiline
                        minRows={3}
                        maxRows={3}
                        onBlur={() => { setObjetivoContratacaoDisabled(true); setObjetivoContratacaoFocused(false); }}
                        inputRef={input => objetivoContratacaoFocused && input && input.focus()}
                        InputProps={{
                            endAdornment: (objetivoContratacaoDisabled &&
                                <InputAdornment position="end">
                                    <IconButton onClick={() => { setObjetivoContratacaoDisabled(!objetivoContratacaoDisabled); setObjetivoContratacaoFocused(true); }}>
                                        <Icon>edit</Icon>
                                    </IconButton>
                                </InputAdornment>)
                        }}
                    />
                    {erros.objetivo && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };


    return (
        <>
            <Grid>
                <Grid
                    container
                    spacing={3}
                    alignItems="flex-start" >
                    {getResponsavelReputacao()}
                    {getNomeSolicitante()}
                    {getEmail()}
                    {getDataRecebimento()}
                    {selectArea()}
                    {selectMarca()}
                    {selectVp()}
                    {getNomeFiguraPublica()}
                    {getSiteEmpresa()}
                    {getObjetivoContratacao()}
                    {selectTipoRelacionamento()}
                    {getPeriodoAcao()}
                    {selectParceiraGB()}
                    {selectDivulgacaoParceria()}
                    {Number(news?.divulgacaoParceria) == 1 && selectCanais()}
                    {/* {selectCanais()} */}
                    {selectAbrangencia()}
                    {getObservacoes()}
                </Grid>
            </Grid>
        </>
    );
}